import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 500px;
  position: relative;
  background: linear-gradient(180deg, #7daff0 0%, #fefefe 100%);
  background-size: contain;
  background-repeat: repeat;

  @media (max-width: 768px) {
    height: 600px;
  }
`;

export const HowItWorksContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const SectionHeading = styled.div`
  font-size: 32px;
  font-weight: 700;
  color: ${theme.blackText};
  line-height: 100%;
  text-align: center;
  width: 100%;
  padding: 50px 0 40px;
`;

export const SectionsContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 18px;
  padding: 0 20px;
`;

export const Separator = styled.div`
  height: 2px;
  background-color: #f0f0f0;
  margin-top: 16px;
  max-width: 100%;
`;

export const SectionWrapper = styled.div``;

export const Section = styled.div<{ isEven: boolean; allignment: string }>`
  display: flex;
  flex-direction: ${(props) => (props.isEven ? "row" : "row-reverse")};
  align-items: ${(props) => props.allignment};
  gap: 10px;
  width: 100%;
`;

export const SectionImage = styled.div`
  flex: 0 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const SectionTag = styled.div<{ bgColors: string[] }>`
  display: inline-block;
  padding: 4px 12px;
  border-radius: 100px;
  background-color: white;
  margin-bottom: 8px;
  background-color: ${(props) => props.bgColors[0] || "#000000"};
`;

export const SectionContent = styled.div`
  width: 100%;
  height: 100%;
  flex: 1;
`;

export const SectionText = styled.div`
  font-size: 16px;
  line-height: 100%;
`;
